import { render, staticRenderFns } from "./rpt_reorder.vue?vue&type=template&id=81975a5e"
import script from "./rpt_reorder.vue?vue&type=script&lang=js"
export * from "./rpt_reorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports